import styled from 'styled-components';
import theme from '../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 30px;
  background-color: ${theme.faqBrackground};
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 20%;

  @media (max-width: 1100px) {
    padding: 20px 10px;
  }
`;

export const Text = styled.p`
  font-size: 24px;
  color: #3d3d3d;
  text-align: center;
`;

export const HighlightText = styled(Text)`
  font-weight: 600;
  color: ${theme.background};
  margin: 0 200px;

  @media (max-width: 1100px) {
    margin: 0;
  }

  @media (max-width: 1280px) {
    margin: 10px;
  }
`;
